import React from "react";
import { ClickAction } from "../../design-system-components/Card/types";
import ClickableCard from "../../design-system-components/Card/ClickableCard";
import Card from "../../design-system-components/Card/Card";
import { UserAvatar } from "../Avatar/Avatar";
import { Icon } from "@evidenceb/athena-common/design-system/Icon";
import cn from "classnames";
import classNames from "classnames";
import { Student } from "../../interfaces/Session";
import { fullName } from "../../utils/format";

import "./UserCard.scss";
import { RawExtra } from "../../interfaces/User";

type Props = {
    user: Omit<Student, "id" | "extra"> & { extra?: RawExtra };
    clickAction?: ClickAction;
    className?: string;
    contentClassName?: string;
    nameClassName?: string;
};

const UserCard = ({
    user,
    clickAction,
    className,
    contentClassName,
    nameClassName,
}: Props) => {
    return (
        <>
            {clickAction ? (
                <ClickableCard
                    className={cn("user-card user-card--clickable", className)}
                    contentClassName={classNames(
                        "user-card__content",
                        contentClassName
                    )}
                    color="var(--text-main-default)"
                    colors={{
                        activeBorder: "var(--text-main-default)",
                    }}
                    clickAction={clickAction}
                >
                    <CardContent
                        user={user}
                        clickAction={clickAction}
                        nameClassName={nameClassName}
                    />
                </ClickableCard>
            ) : (
                <Card
                    className={cn(
                        "user-card user-card--not-clickable",
                        className
                    )}
                    contentClassName={classNames(
                        "user-card__content",
                        contentClassName
                    )}
                    color="var(--text-main-default)"
                    colors={{
                        borderHover: "var(--text-main-default)",
                    }}
                >
                    <CardContent
                        user={user}
                        clickAction={clickAction}
                        nameClassName={nameClassName}
                    />
                </Card>
            )}
        </>
    );
};

const CardContent = ({ user, clickAction, nameClassName }: Props) => {
    return (
        <>
            <UserAvatar user={user} />
            <p
                className={classNames(
                    "user-card__content__name",
                    nameClassName
                )}
            >
                <span>{fullName(user)}</span>
            </p>
            {clickAction && (
                <Icon
                    className="user-card__content__icon"
                    path="chevron_right"
                    size="medium"
                />
            )}
        </>
    );
};

export default UserCard;
